import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';

import { tradWithColors } from '@/utils/trad';

import Hero from '@/components/Hero';

const PortfolioHero = () => {
  const { t } = useTranslation();

  const htmlContent = useMemo(() => tradWithColors(t('heroTitle')), []);

  const data = useStaticQuery(graphql`
    query {
      folder: file(relativePath: { eq: "folder.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
    }
  `);

  return (
    <Hero
      fullHeight
      title={htmlContent}
      subTitle={<div>{t('heroSubtitle')}</div>}
      image={{
        image: getImage(data.folder),
        alt: 'folder icon',
      }}
    />
  );
};

export default PortfolioHero;
